import * as React from "react";
import { IProductModel } from "../../models";
import { ProductContainer } from "..";

import "./product-list.scss";

interface IProductListProps {
  products: IProductModel[];
}
export const ProductList: React.FC<IProductListProps> = ({ products }) => {
  const baseClassName = "product-list";

  return (
    <div className={baseClassName}>
      {products.map(product => (
        <ProductContainer key={product.url} product={product} />
      ))}
    </div>
  );
};
